import * as Yup from "yup";
export const campaignDateValidation = {
    campaign_range_start: Yup.string().required('Campaign start is required'),

    campaign_range_end: Yup.string().required('Campaign end is required'),

    campaign_range: Yup.array()
        .of(Yup.string().required())
        .test(
            'range-valid',
            'Campaign range must have both start and end dates',
            function (value) {
                const { campaign_range_start, campaign_range_end } = this.parent;
                return (
                    typeof campaign_range_start === 'string' &&
                    campaign_range_start.trim() !== '' &&
                    typeof campaign_range_end === 'string' &&
                    campaign_range_end.trim() !== ''
                );
            }
        ),
};